// Define constants for error keys
const REQUIRED = 'required';
const MIN_VALUE = 'minValue';
const MAX_VALUE = 'maxValue';
const INAPPROPRIATE = 'inappropriate';

// Define the type for FieldErrorKey based on the constants
type FieldErrorKey = typeof REQUIRED | typeof MIN_VALUE | typeof MAX_VALUE | typeof INAPPROPRIATE;

type GetFieldError = {
    key: FieldErrorKey;
    params?: Record<string, string | number | boolean | null | undefined>;
};

export const getFieldErrorKey = ({
    hasError,
    type,
    options,
}: {
    hasError: boolean;
    type?: string;
    options?: {
        minLength?: number;
        maxLength?: number;
        field?: string;
    };
}): GetFieldError | undefined => {
    if (!hasError) return undefined;

    const { minLength, maxLength, field } = options ?? {};

    if (type === REQUIRED && (!field || field.length === 0)) {
        return { key: REQUIRED };
    }

    if (type === INAPPROPRIATE) {
        return { key: INAPPROPRIATE };
    }

    if (minLength && field && field.length < minLength) {
        return { key: MIN_VALUE, params: { minValue: minLength } };
    }

    if (maxLength && field && field.length > maxLength) {
        return { key: MAX_VALUE, params: { maxValue: maxLength } };
    }

    return undefined;
};
